import moment from 'moment';

export const formatDate = (date) => {
    if (!date) return '';
    return moment.utc(date).format('MMM D, YYYY');
}

export const formatDateTime = (date) => {
    if (!date) return '';
    return moment.utc(date).local().format('MMM D, YYYY, HH:mm');
};

export const formatFormExpirationDate = (date) => {
    if (!date) return '';
    return moment.utc(date).local().format('MMM D, YYYY, HH:mm z');
};

export const toFormExpirationMoment = (date) => (date ? moment.utc(date).local() : null);

export const toFormExpirationIso = (value) => {
    if (!value) return null;

    return value.clone().utc().seconds(0).milliseconds(0).toISOString();
};

export const isDateExpired = dateToCheck => {
    const date = new Date(dateToCheck);
    const currentDate = new Date();

    return date < currentDate;
};
